<template>
  <div class="dropdown">
    <a
      href="#"
      @click.prevent="showHelp"
    >
      <span class="sr-only">{{ $localize('ScreenReaderHelpLink') }}</span>
      <span
        v-tooltip.bottom="{
          value: $localize('OpenHelpInNewWindow'),
          showDelay: 600
        }"
        aria-hidden="true"
        class="fas fa-circle-question help-icon"
      />
    </a>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import redirectHelper from '@/Utils/redirectHelper';

const props = withDefaults(defineProps<{
        helpId?: string | null;
    }>(), {
  helpId: null
});

const router = useRouter();
const showHelp = () => {
  // If the component is called from the Registration Page, there is no router instance available.
  if (props.helpId) {
    redirectHelper.openHelpWindow(props.helpId);
  } else {
    const currentRouteName = router.currentRoute.value.name as string;
    redirectHelper.openHelpWindow(null, currentRouteName);
  }
};
</script>
